<template>
  <div :class="mediaImageClass" :style="mediaImageStyle">
    <v-progress-circular indeterminate color="grey lighten-2" v-if="src && !loaded"></v-progress-circular>

    <img ref="image"
         v-show="loaded"
         :src="src"
         :alt="alt"
         :style="imageStyle"
         @load="start" />

    <nx-media-info v-if="!src" :icon="info"></nx-media-info>
  </div>
</template>

<script>
import MediaInfo from '@/components/media/MediaInfo';

/**
 * MediaImage Component
 *
 * ...
 *
 * @property {String}  src
 * @property {String}  alt
 * @property {Number}  width
 * @property {Number}  height
 * @property {String}  info    media information
 */
export default {
  name: 'nx-media-image',
  props: {
    src: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    },
    alt: {
      type: String,
      default: 'Media Image',
    },
    width: Number,
    height: Number,
    info: String,
  },
  data() {
    return {
      image: {
        width: 1,
        height: 1,
      },
      loaded: false,
    };
  },
  computed: {
    mediaImageClass() {
      return {
        'nx-media-image': true,
        'nx-media-image--empty': !this.src,
      };
    },
    mediaImageStyle() {
      return {
        paddingTop: this.padding,
      };
    },
    imageStyle() {
      return {
        marginTop: this.margin,
      };
    },
    margin() {
      return `${-this.verticalRatio}%`;
    },
    padding() {
      return `${this.verticalRatio}%`;
    },
    verticalRatio() {
      return (this.image.height / this.image.width).toFixed(4) * 100;
    },
    hasDimension() {
      return this.src && this.width && this.height;
    },
  },
  components: {
    [MediaInfo.name]: MediaInfo,
  },
  methods: {
    start() {
      if (!this.hasDimension) {
        this.setDimension(this.$refs.image.width, this.$refs.image.height);
      }

      this.loaded = true;
    },
    setDimension(width, height) {
      this.image.width = width;
      this.image.height = height;
    },
  },
  mounted() {
    if (this.hasDimension) {
      this.setDimension(this.width, this.height);
    }
  },
};
</script>

<style lang="stylus">
.nx-media-image {
  display: table;
  position: relative;
  width: 100%;
  margin: 0 auto;
  table-layout: fixed;

  img {
    display: block;
    height: auto;
    border-radius: 0;
  }

  .progress-circular {
    margin: auto;
  }
}

.nx-media-image--empty {
  background-color: #fff;
  outline-width: 2px;
  outline-style: solid;
  outline-color: #E1E1E6;
  outline-offset: -2px;
}
</style>
